var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgNewFront4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 212,
    viewBox: "0 0 342 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_3078)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 212,
    rx: 20,
    fill: "url(#paint0_linear_122_3078)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M447 122.094C545 395.094 252.28 380.594 112 380.594C-28.2803 380.594 -142 272.023 -142 138.094C-142 4.16454 -64.2803 183.094 76 183.094C217.5 190.094 349 -84.4063 447 122.094Z",
    fill: "#FD4D12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M232.525 106.624C232.525 106.624 224.495 93.5024 222.769 85.5513C221.037 77.6068 221.694 70.0804 221.846 69.4101C221.992 68.7331 225.683 62.4279 226.731 61.7377C227.773 61.0474 241.419 58.5254 242.275 59.0563C243.131 59.5873 232.532 106.624 232.532 106.624H232.525Z",
    fill: "#D1FF86"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M271.299 105.044C271.299 105.044 269.998 108.024 268.876 110.394C268.618 110.931 268.365 111.436 268.166 111.88C267.775 112.624 267.489 113.115 267.363 113.194C263.275 115.577 247.844 119.964 243.563 120.92C242.906 121.066 242.521 121.132 242.461 121.093C241.008 120.044 221.953 100.989 222.384 73.8304C222.384 73.7773 222.384 73.764 222.384 73.764C222.404 72.2773 222.504 70.7508 222.65 69.1977C222.683 68.8128 226.944 62.4545 226.944 62.4545L271.166 104.938L271.292 105.051L271.299 105.044Z",
    fill: "#226933"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M271.299 105.044C271.299 105.044 267.867 112.889 267.363 113.194C262.644 115.936 242.853 121.371 242.461 121.092C242.461 121.092 243.861 115.59 245.72 113.871C246.802 112.889 260.069 108.502 271.173 104.938L271.299 105.051V105.044Z",
    fill: "url(#paint1_linear_122_3078)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M271.299 105.044C271.909 105.861 247.113 114.807 245.72 113.865C244.89 113.301 237.755 105.555 232.519 92.9184V92.9052C230.979 89.2017 229.592 85.0669 228.589 80.567C227.362 75.0317 226.671 68.9655 226.943 62.4479C226.997 61.3462 253.511 56.0167 253.465 56.5808C253.332 57.8551 253.279 59.2091 253.359 60.6626C253.843 72.3703 260.6 89.1951 268.876 101.6C269.673 102.788 270.496 103.943 271.305 105.038L271.299 105.044Z",
    fill: "url(#paint2_linear_122_3078)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M263.819 103.79C259.93 104.507 256.445 97.1462 262.067 96.3365C262.067 96.3365 257.806 89.3676 255.576 82.578C252.967 74.66 252.516 70.2398 252.516 70.2398C248.248 71.2088 245.414 66.2377 249.337 61.8108C250.147 60.8816 232.34 64.2134 233.388 65.4412C237.629 70.4323 232.884 73.1468 230.84 72.9012C230.84 72.9012 231.437 81.5094 234.563 89.5668C237.052 95.9781 242.833 103.193 242.833 103.193C247.95 100.923 250.664 105.409 249.131 108.588C248.819 109.219 265.239 103.531 263.812 103.797L263.819 103.79ZM248.348 93.9273C244.618 95.5002 240.171 93.3233 238.512 90.3831C235.014 84.1377 237.835 79.3325 242.043 78.5228C246.251 77.7131 251.375 79.2528 252.782 84.1443C254.136 88.8898 251.288 92.6928 248.348 93.9273Z",
    fill: "#3BCC62"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M246.795 112.591C244.173 112.776 234.032 96.5422 235.738 92.1817C237.443 87.8212 254.573 81.4696 257.016 83.4408C259.458 85.412 269.447 103 268.425 104.467C267.403 105.934 252.934 112.159 246.795 112.591Z",
    fill: "#FCFFA1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M271.299 105.044C271.909 105.861 247.113 114.807 245.72 113.865C244.89 113.301 237.755 105.555 232.519 92.9184C232.87 93.5821 242.102 111.635 246.536 112.564C251.062 113.506 269.095 106.677 269.274 104.639C269.314 104.095 269.155 102.973 268.869 101.6C269.666 102.788 270.489 103.942 271.299 105.038V105.044Z",
    fill: "#D9CFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M253.472 56.5808C253.339 57.8551 253.286 59.2091 253.365 60.6626C252.894 59.6803 252.416 58.8507 251.972 58.3927C250.253 56.6074 230.866 60.5896 228.676 62.6603C226.472 64.7311 228.636 80.6267 228.636 80.6267L228.603 80.567C227.375 75.0317 226.685 68.9655 226.957 62.4479C227.01 61.3462 253.525 56.0167 253.478 56.5808H253.472Z",
    fill: "#D9CFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M232.32 87.861C229.094 86.7261 225.842 66.3173 230.229 63.3704C234.616 60.4236 248.919 58.24 250.757 60.7355C252.596 63.2311 256.399 79.5249 254.74 80.6997C253.08 81.8744 234.762 88.7238 232.32 87.861Z",
    fill: "#912774"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M268.876 110.387C268.179 111.854 267.562 113.075 267.363 113.188C263.275 115.571 247.844 119.958 243.563 120.913C243.496 120.86 243.45 120.781 243.417 120.721C242.288 118.809 259.538 109.703 264.449 108.887C266.401 108.562 267.847 109.338 268.87 110.387H268.876Z",
    fill: "url(#paint3_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M268.166 111.874C267.775 112.617 267.489 113.108 267.363 113.188C263.275 115.57 247.844 119.958 243.563 120.913C242.906 121.059 242.521 121.126 242.461 121.086C241.008 120.037 221.953 100.982 222.384 73.8237C222.477 75.3568 224.581 106.226 242.806 119.831C245.156 121.577 259.22 115.829 268.16 111.867L268.166 111.874Z",
    fill: "url(#paint4_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M247.485 111.509C241.127 110.214 256.465 88.9628 262.325 93.8277C268.186 98.686 267.807 103.723 266.633 104.858C265.465 105.993 253.053 112.644 247.478 111.509H247.485Z",
    fill: "#FCFFA1"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M271.299 105.044C270.489 103.942 269.666 102.794 268.87 101.606C260.6 89.2016 253.843 72.3768 253.352 60.6691C253.279 59.2156 253.326 57.8617 253.458 56.5874C253.505 56.0232 226.99 61.3594 226.937 62.4545C226.937 62.4545 222.683 68.8061 222.643 69.1977C222.497 70.7507 222.397 72.2706 222.377 73.7639C222.377 73.7639 222.377 73.7772 222.377 73.8303C221.946 100.982 241.001 120.044 242.454 121.092C242.468 121.099 242.501 121.106 242.554 121.099C242.594 121.099 242.653 121.092 242.72 121.079C242.733 121.079 242.74 121.079 242.76 121.079C242.819 121.073 242.892 121.059 242.965 121.046C243.005 121.039 243.045 121.033 243.085 121.026C243.151 121.013 243.224 121 243.304 120.98C243.364 120.966 243.423 120.953 243.496 120.94C243.523 120.94 243.543 120.933 243.569 120.927C243.642 120.907 243.735 120.887 243.815 120.867C243.875 120.854 243.934 120.84 243.994 120.827L244.041 120.814C246.841 120.157 252.888 118.477 258.264 116.732H258.284C258.522 116.646 258.755 116.573 258.987 116.493C259.093 116.46 259.193 116.427 259.299 116.393C259.478 116.334 259.664 116.274 259.843 116.214C260.003 116.161 260.155 116.108 260.308 116.055C260.447 116.008 260.587 115.962 260.719 115.916C260.918 115.849 261.118 115.776 261.317 115.71C261.41 115.677 261.509 115.643 261.602 115.61C262.511 115.292 263.367 114.973 264.144 114.668C264.184 114.655 264.224 114.635 264.263 114.621C264.476 114.535 264.688 114.455 264.887 114.369C264.94 114.349 264.994 114.323 265.047 114.303C265.226 114.23 265.398 114.157 265.571 114.077C265.631 114.051 265.684 114.024 265.744 114.004C265.903 113.931 266.055 113.865 266.201 113.798C266.255 113.772 266.308 113.752 266.361 113.725C266.507 113.659 266.646 113.586 266.772 113.52C266.812 113.5 266.859 113.48 266.898 113.453C267.064 113.367 267.224 113.281 267.363 113.201C267.383 113.188 267.409 113.161 267.436 113.128C267.449 113.108 267.469 113.088 267.489 113.062V113.048C267.542 112.982 267.602 112.896 267.662 112.796L267.675 112.776C267.715 112.71 267.748 112.644 267.794 112.571C267.907 112.371 268.027 112.152 268.173 111.887C268.246 111.728 268.325 111.555 268.412 111.383C268.564 111.077 268.724 110.745 268.889 110.4C269.865 108.336 270.98 105.814 271.252 105.197C271.305 105.137 271.339 105.084 271.312 105.051L271.299 105.044Z",
    fill: "url(#paint5_linear_122_3078)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M263.912 47.196C263.912 47.196 267.124 42.9947 268.863 32.8667C270.602 22.7452 269.958 19.8913 270.19 19.6988C270.423 19.5064 278.38 15.3118 279.276 15.3118C280.172 15.3118 296.446 22.5395 297.734 23.3956C299.021 24.2518 263.905 47.2026 263.905 47.2026L263.912 47.196Z",
    fill: "#D1FF86"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M288.734 75.3502C288.701 75.3834 288.701 75.4033 288.701 75.4033C287.739 76.5316 286.697 77.6466 285.582 78.7616C285.309 79.0337 277.989 81.2107 277.989 81.2107L276.522 68.5937L270.94 20.3028L270.92 20.1369C270.92 20.1369 273.821 18.6701 276.184 17.5551C276.741 17.3029 277.245 17.064 277.684 16.8649C278.46 16.5463 278.998 16.3405 279.137 16.3605C283.809 17.137 298.504 23.5616 302.4 25.5527C302.718 25.7186 302.957 25.858 303.123 25.9576C303.276 26.0439 303.362 26.0903 303.362 26.1235C303.82 27.8624 306.362 54.6826 288.734 75.3502Z",
    fill: "#226933"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M288.734 75.3502C288.701 75.3834 288.701 75.4033 288.701 75.4033C287.739 76.5316 286.697 77.6466 285.581 78.7616C285.309 79.0337 277.989 81.2107 277.989 81.2107L276.522 68.5937L296.26 29.6212C296.26 29.6212 300.442 26.6213 303.13 25.9576C303.282 26.0439 303.369 26.0903 303.369 26.1235C303.827 27.8624 306.369 54.6826 288.741 75.3502H288.734Z",
    fill: "url(#paint6_linear_122_3078)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M270.92 20.1302C270.967 19.1147 295.783 28.0083 296.261 29.6211C296.546 30.5835 297.11 41.0965 293.095 54.1714V54.1847C291.913 58.0209 290.347 62.0894 288.256 66.1911C285.681 71.2418 282.343 76.3523 277.989 81.2106C277.246 82.027 253.412 69.2441 253.804 68.8459C254.72 67.9499 255.622 66.9344 256.485 65.7663C263.567 56.4347 269.075 39.1585 270.595 24.3248C270.741 22.8978 270.841 21.4908 270.914 20.1236L270.92 20.1302Z",
    fill: "url(#paint7_linear_122_3078)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.8
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M275.885 25.858C279.336 27.7828 277.332 35.6742 272.487 32.7207C272.487 32.7207 271.332 40.8046 268.73 47.4681C265.697 55.2334 263.228 58.9302 263.228 58.9302C267.137 60.9014 266.155 66.5363 260.308 67.4588C259.093 67.6579 274.936 76.432 274.909 74.8192C274.816 68.2685 280.212 69.1977 281.626 70.691C281.626 70.691 286.65 63.6757 289.365 55.4657C291.528 48.9415 291.668 39.6962 291.668 39.6962C286.272 38.1896 287.042 32.9994 290.247 31.5194C290.891 31.2274 274.611 25.1545 275.872 25.8647L275.885 25.858ZM281.533 43.32C285.409 44.4815 287.453 48.9946 286.863 52.3198C285.582 59.3616 280.352 61.2665 276.588 59.209C272.825 57.1515 269.859 52.7047 271.889 48.0323C273.867 43.5125 278.48 42.3908 281.54 43.3134L281.533 43.32Z",
    fill: "#3BCC62"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M294.621 29.9198C296.758 31.4464 294.243 50.4216 290.148 52.6914C286.053 54.9613 268.803 48.9548 268.173 45.8818C267.542 42.8089 271.047 22.8846 272.766 22.4067C274.485 21.9289 289.61 26.3425 294.621 29.9198Z",
    fill: "#FCFFA1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M270.921 20.1302C270.967 19.1147 295.783 28.0083 296.261 29.6211C296.546 30.5835 297.11 41.0965 293.095 54.1714C293.248 53.4347 297.628 33.6432 294.801 30.099C291.913 26.4885 273.662 20.263 272.221 21.7297C271.85 22.128 271.252 23.0903 270.602 24.3314C270.748 22.9045 270.848 21.4974 270.921 20.1302Z",
    fill: "#D9CFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M253.804 68.8459C254.72 67.9499 255.622 66.9344 256.485 65.7663C256.226 66.8282 256.06 67.7707 256.113 68.4012C256.306 70.8702 273.781 80.1487 276.788 79.9496C279.807 79.7571 288.263 66.1247 288.263 66.1247L288.25 66.1911C285.675 71.2418 282.336 76.3523 277.982 81.2106C277.239 82.027 253.405 69.2441 253.797 68.8459H253.804Z",
    fill: "#D9CFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M290.028 58.2068C291.794 61.1403 281.301 78.9408 276.044 78.4231C270.788 77.8988 258.37 70.4786 258.536 67.3791C258.708 64.2863 266.148 49.2999 268.179 49.4526C270.21 49.6052 288.688 55.99 290.022 58.2068H290.028Z",
    fill: "#912774"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M277.684 16.8583C278.46 16.5331 278.998 16.3406 279.137 16.3539C283.803 17.1237 298.497 23.5616 302.406 25.5528C303.004 25.8647 303.342 26.0572 303.369 26.1235C303.827 27.8558 306.375 54.6892 288.747 75.3436C289.65 74.1025 307.69 48.9681 302.307 26.8669C301.61 24.0196 287.108 19.4998 277.69 16.8583H277.684Z",
    fill: "url(#paint8_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M293.4 30.3181C297.475 35.3622 272.115 41.9793 270.695 34.4994C269.274 27.0195 272.772 23.3824 274.398 23.2497C276.024 23.1169 289.823 25.8978 293.4 30.3181Z",
    fill: "#FCFFA1"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M303.368 26.1235C303.368 26.1235 303.335 26.0903 303.315 26.0704C303.315 26.0704 303.315 26.0638 303.302 26.0572C303.183 25.9642 302.904 25.8116 302.486 25.5926C302.453 25.5793 302.433 25.566 302.399 25.5461C300.614 24.6302 296.552 22.7851 292.225 20.9799C287.128 18.8427 281.665 16.7653 279.137 16.3539C278.991 16.3406 278.453 16.5331 277.683 16.8583C277.245 17.064 276.741 17.3029 276.183 17.5552C274.139 18.5175 271.69 19.7454 271.073 20.0573C270.98 20.0639 270.92 20.0839 270.92 20.1303C270.847 21.4975 270.748 22.9046 270.602 24.3315C269.082 39.1653 263.566 56.4348 256.491 65.773C255.628 66.9411 254.726 67.9566 253.81 68.8526C253.412 69.2575 277.252 82.0337 277.995 81.2173H278.002C278.002 81.2173 285.322 79.0338 285.588 78.7617C286.703 77.6466 287.745 76.5316 288.707 75.4033C288.707 75.4033 288.707 75.3834 288.74 75.3502C288.754 75.337 288.76 75.3237 288.774 75.3104L288.747 75.3436C306.375 54.6826 303.826 27.8558 303.368 26.1235Z",
    fill: "url(#paint9_linear_122_3078)"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M235.193 139.815C235.193 139.815 240.583 155.014 243.111 172.848C245.64 190.681 240.065 205.588 240.065 205.588C240.065 205.588 256.87 188.797 248.255 167.704C239.64 146.612 235.193 139.815 235.193 139.815Z",
    fill: "#D1FF86"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M242.481 138.74C242.481 138.74 246.509 140.141 248.248 127.331C249.987 114.522 251.54 80.8656 250.067 76.8767C248.587 72.8879 252.934 73.7905 252.934 73.7905C252.934 73.7905 255.403 111.349 252.317 125.752C249.231 140.161 247.83 148.51 242.487 138.74H242.481Z",
    fill: "#D1FF86"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.48 220.88C278.221 221.942 274.146 222.433 269.64 221.524C265.717 220.754 258.304 217.429 256.551 217.329C256.293 217.316 256.16 217.376 256.18 217.522C256.346 218.67 258.854 221.69 257.706 221.524C257.686 221.524 257.66 221.524 257.627 221.504H257.613C256.346 221.179 251.959 217.203 245.766 219.075C237.37 221.617 231.185 222.041 230.05 221.039H230.037C229.725 220.741 229.824 220.329 230.422 219.811C239.089 212.285 247.233 194.869 243.629 168.852C242.587 161.313 239.766 152.101 236.328 142.822C234.171 136.995 231.769 131.148 229.419 125.665C226.4 118.657 223.459 112.259 221.196 107.334C218.342 101.108 216.577 97.2125 217.121 97.3718C224.196 99.4027 229.393 112.703 234.072 123.807C237.191 131.221 240.078 137.658 243.118 139.125C243.782 139.45 244.452 139.537 245.136 139.331C248.414 138.395 249.868 126.555 250.552 112.405C250.883 105.416 251.029 97.8563 251.089 90.7746C251.149 84.5093 251.149 78.609 251.182 73.7971C251.222 66.3106 251.328 61.439 251.813 61.8704C252.211 62.2288 252.576 62.6669 252.901 63.1846C252.921 63.2177 252.921 63.231 252.934 63.2509C254.375 65.5938 255.038 69.4034 255.317 73.7971C255.655 79.266 255.403 85.6508 255.317 91.2458C255.198 99.3231 255.43 105.761 258.324 105.422C258.37 105.416 258.416 105.416 258.463 105.396C260.806 105.084 262.697 103.425 264.277 100.936C265.697 98.7125 266.879 95.8519 267.921 92.706C267.954 92.6197 267.974 92.5268 268.007 92.4405C268.04 92.3476 268.053 92.2945 268.053 92.2945C271.836 80.6996 273.907 65.4677 279.469 64.3195C279.721 64.2664 273.887 80.1089 268.06 100.77C266.832 105.137 265.604 109.71 264.436 114.402C264.436 114.449 264.403 114.555 264.357 114.714C263.646 117.555 262.969 120.435 262.312 123.329C257.819 143.353 254.972 164.187 257.952 178.191C259.565 185.77 261.443 192.009 263.401 197.146C263.739 198.055 264.091 198.931 264.436 199.774C269.334 211.601 274.471 216.884 276.96 219.227L276.987 219.254C277.976 220.196 278.533 220.654 278.48 220.887V220.88Z",
    fill: "url(#paint10_linear_122_3078)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M255.317 91.2392C254.042 91.5313 252.529 91.3056 251.089 90.768C251.149 84.5027 251.149 78.6024 251.182 73.7905H255.317C255.655 79.2594 255.403 85.6442 255.317 91.2392Z",
    fill: "url(#paint11_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M268.06 100.763C266.832 105.13 265.604 109.71 264.429 114.402C264.429 114.449 264.396 114.548 264.35 114.714C263.64 117.555 262.963 120.435 262.306 123.329C255.025 116.991 256.352 109.896 258.456 105.403C260.799 105.084 262.691 103.425 264.277 100.943L268.06 100.77V100.763Z",
    fill: "url(#paint12_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M244.631 148.543C238.485 148.132 233.262 122.135 228.43 114.681C224.88 109.226 222.802 107.234 221.196 107.334C218.342 101.108 216.57 97.2059 217.121 97.3719C225.829 99.874 231.716 119.48 237.258 131.021C239.01 134.672 240.722 137.512 242.481 138.747C242.481 138.747 242.481 138.754 242.488 138.754C243.357 139.371 244.24 139.59 245.136 139.331C248.408 138.389 249.868 126.548 250.545 112.405C250.545 112.405 250.764 148.961 244.625 148.543H244.631Z",
    fill: "url(#paint13_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M244.107 147.999C241.492 148.556 234.921 134.519 237.264 131.015C239.016 134.665 240.729 137.506 242.487 138.74C242.487 138.74 242.487 138.747 242.494 138.747C244.094 141.07 246.768 147.441 244.107 147.999Z",
    fill: "url(#paint14_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M243.118 139.119C242.162 142.47 239.142 143.041 236.328 142.815C234.178 136.988 231.775 131.141 229.419 125.659L234.072 123.8C237.191 131.214 240.078 137.652 243.118 139.119Z",
    fill: "url(#paint15_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M267.92 92.6994C266.951 95.8918 260.454 116.447 255.629 116.068C250.399 115.67 254.407 89.0092 254.567 79.3457C254.713 70.2597 253.213 64.1337 252.934 63.251C258.781 72.7154 251.812 106.173 258.323 105.423C262.83 104.905 265.684 99.4625 267.92 92.6994Z",
    fill: "url(#paint16_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M264.429 199.768C263.5 200.796 257.832 185.472 253.916 168.467C250.147 152.154 263.221 118.391 264.356 114.714C258.761 137.181 254.534 162.156 257.952 178.191C259.85 187.111 262.12 194.179 264.429 199.774V199.768Z",
    fill: "url(#paint17_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M256.186 217.522C256.186 217.522 244.512 209.663 247.459 198.898C250.166 188.996 245.627 154.848 245.627 154.848C245.627 154.848 252.184 178.45 250.107 185.352C247.2 195.002 249.987 210.267 256.18 217.522H256.186Z",
    fill: "url(#paint18_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M257.613 221.497C256.345 221.172 251.958 217.196 245.759 219.068C237.37 221.617 231.184 222.041 230.05 221.039C230.946 221.537 232.525 221.537 235.85 220.701C239.195 219.878 245.056 210.307 248.116 213.281C251.175 216.254 255.018 220.17 257.407 221.378C257.48 221.404 257.54 221.451 257.613 221.497Z",
    fill: "#C15DAD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M278.473 220.88C278.221 221.942 274.146 222.426 269.639 221.53C265.133 220.634 256.02 216.38 256.18 217.528C255.343 216.937 252.423 210.964 255.25 211.21C258.065 211.442 264.111 219.791 271.252 220.734C278.361 221.69 278.188 220.966 276.98 219.247C277.969 220.19 278.526 220.648 278.467 220.88H278.473Z",
    fill: "#C15DAD"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M187.898 96.3563C187.898 96.3563 181.367 88.3123 181.108 87.4959C180.85 86.6796 181.108 79.4917 181.321 78.6953C181.533 77.8922 200.781 57.9015 201.066 58.4059C204.537 64.6049 210.663 75.098 231.377 86.1088C252.091 97.1196 187.898 96.3563 187.898 96.3563Z",
    fill: "#D1FF86"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M243.735 99.9071C243.735 99.9934 243.729 100.066 243.722 100.113C243.722 100.146 243.715 100.159 243.709 100.173C243.092 101.394 241.777 103.259 240.145 105.376C239.833 105.774 239.514 106.186 239.196 106.597C239.083 106.737 238.97 106.876 238.864 107.015C238.638 107.287 238.419 107.573 238.193 107.852C238.054 108.011 237.921 108.183 237.782 108.343C237.775 108.349 237.782 108.349 237.782 108.349C237.649 108.502 237.53 108.668 237.397 108.814C237.198 109.06 236.999 109.305 236.793 109.544H236.786C236.554 109.836 236.315 110.122 236.083 110.4C235.718 110.825 235.366 111.25 235.021 111.668C234.988 111.701 234.961 111.728 234.935 111.761C234.523 112.245 234.118 112.717 233.713 113.188C233.202 113.765 232.718 114.329 232.247 114.867C231.802 115.378 231.377 115.856 230.972 116.307C230.86 116.42 230.753 116.533 230.674 116.639C230.468 116.865 230.275 117.07 230.096 117.283C229.851 117.548 229.618 117.794 229.399 118.033C229.028 118.444 228.689 118.803 228.397 119.115C228.218 119.294 228.065 119.453 227.926 119.593C227.84 119.679 227.767 119.752 227.7 119.825C227.362 120.163 227.149 120.342 227.096 120.342C226.081 120.289 217.055 118.431 206.827 112.564C199.148 108.164 190.785 101.507 184.606 91.6507C184.586 91.6175 184.566 91.5976 184.553 91.5711C184.533 91.5246 184.52 91.518 184.52 91.518C183.723 90.2503 182.973 88.9229 182.257 87.5424C182.078 87.1973 182.197 79.5448 182.197 79.5448L183.836 79.8634L185.263 80.1421L193.102 81.6554L204.716 83.8987L211.745 85.2593L213.033 85.5048L217.758 86.4141L225.882 87.9871L229.738 88.7304L236.979 90.1242L237.755 90.2768L239.614 90.6286L242.401 91.1662L242.574 91.1861C242.574 91.1861 242.58 91.2458 242.607 91.3587C242.6 91.3587 242.607 91.3653 242.607 91.3653C242.607 91.3786 242.607 91.3985 242.614 91.4118C242.62 91.4649 242.627 91.5379 242.647 91.6109C242.667 91.7436 242.693 91.8963 242.713 92.0688C242.726 92.1551 242.746 92.248 242.76 92.341C242.8 92.5865 242.846 92.8719 242.892 93.1839C242.926 93.3896 242.959 93.6153 242.992 93.8476C243.032 94.0998 243.072 94.3652 243.105 94.6241C243.118 94.7502 243.145 94.8697 243.158 94.9958C243.224 95.4603 243.297 95.9449 243.357 96.4094C243.357 96.4426 243.364 96.4692 243.37 96.5024C243.39 96.6749 243.417 96.8342 243.437 96.9935C243.457 97.2258 243.49 97.4515 243.516 97.6638C243.523 97.7169 243.53 97.77 243.536 97.8165C243.543 97.916 243.556 98.009 243.569 98.1019C243.569 98.1152 243.576 98.1351 243.576 98.1483C243.583 98.1882 243.583 98.2147 243.589 98.2545C243.596 98.2877 243.596 98.3143 243.603 98.3408C243.609 98.4404 243.622 98.5333 243.642 98.6262C243.656 98.7722 243.662 98.9116 243.676 99.0377C243.709 99.4094 243.722 99.6948 243.715 99.8939L243.735 99.9071Z",
    fill: "#2E8F46"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M243.715 100.113C243.715 100.113 243.708 100.159 243.702 100.173C243.085 101.394 241.77 103.259 240.138 105.376C239.826 105.774 239.507 106.186 239.189 106.597C239.076 106.737 238.963 106.876 238.857 107.015C238.631 107.288 238.412 107.573 238.186 107.852C238.047 108.011 237.914 108.184 237.775 108.343C237.768 108.349 237.775 108.349 237.775 108.349C237.642 108.502 237.523 108.668 237.39 108.814C237.191 109.06 236.992 109.305 236.786 109.544H236.779C236.547 109.836 236.308 110.122 236.076 110.4C235.711 110.825 235.359 111.25 235.014 111.668C234.981 111.701 234.954 111.728 234.928 111.761C234.516 112.245 234.111 112.717 233.706 113.188C233.195 113.765 232.711 114.329 232.24 114.867C231.802 115.371 231.377 115.856 230.965 116.307C230.853 116.42 230.746 116.533 230.667 116.639C230.468 116.865 230.275 117.07 230.089 117.283C229.844 117.548 229.611 117.794 229.392 118.033C229.027 118.444 228.689 118.803 228.39 119.115C228.118 119.4 227.886 119.639 227.693 119.825C227.355 120.163 227.142 120.343 227.089 120.343C227.089 120.343 226.93 119.851 226.711 119.101C226.22 117.363 225.463 114.217 225.895 112.511C225.988 112.172 226.558 111.283 227.474 110.002C227.753 109.63 228.052 109.226 228.377 108.781C228.39 108.774 228.397 108.761 228.397 108.748C228.881 108.104 229.412 107.407 230.003 106.644C231.012 105.336 232.153 103.889 233.381 102.343H233.388C233.706 101.931 234.018 101.533 234.35 101.122C234.928 100.392 235.532 99.6417 236.149 98.8851C237.463 97.2391 238.824 95.5599 240.178 93.9007C240.928 92.9848 241.664 92.0689 242.401 91.1795L242.573 91.1994C242.573 91.1994 242.58 91.2591 242.607 91.372C242.6 91.372 242.607 91.3786 242.607 91.3786C242.607 91.3919 242.607 91.4118 242.613 91.4251C242.62 91.4782 242.627 91.5512 242.646 91.6242C242.666 91.7569 242.693 91.9096 242.713 92.0821C242.726 92.1684 242.746 92.2613 242.759 92.3543C242.799 92.5998 242.846 92.8852 242.892 93.1972C242.925 93.4029 242.952 93.6286 242.992 93.8609C243.031 94.1131 243.071 94.3785 243.104 94.6374C243.118 94.7635 243.144 94.883 243.158 95.0091C243.224 95.4737 243.297 95.9515 243.357 96.4227C243.357 96.4559 243.363 96.4825 243.37 96.5157C243.383 96.6749 243.41 96.8475 243.43 97.0068C243.463 97.2391 243.489 97.4648 243.516 97.6771C243.523 97.7302 243.529 97.7833 243.536 97.8298C243.542 97.9293 243.556 98.0223 243.569 98.1152C243.569 98.1285 243.576 98.1484 243.576 98.1616C243.589 98.3408 243.615 98.5068 243.629 98.6727C243.708 99.3895 243.735 99.9205 243.695 100.113H243.715Z",
    fill: "url(#paint19_linear_122_3078)"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M242.58 91.1994C243.536 91.5512 227.581 112.537 225.902 112.504C224.899 112.484 214.698 109.856 203.442 102.091L203.429 102.077C200.123 99.801 196.712 97.0864 193.433 93.8542C189.398 89.8786 185.522 85.1597 182.203 79.5382C181.653 78.5891 201.013 59.7002 201.278 60.2046C201.856 61.3461 202.553 62.5142 203.402 63.689C210.172 73.2529 224.986 83.7062 238.671 89.6264C239.985 90.1906 241.299 90.7149 242.58 91.1928V91.1994Z",
    fill: "url(#paint20_linear_122_3078)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.8
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M235.625 94.2193C232.744 96.9338 225.822 92.6463 230.109 88.9097C230.109 88.9097 229.983 88.8499 229.758 88.7305C229.233 88.4783 228.178 87.934 226.817 87.184C224.289 85.7903 220.711 83.6598 217.605 81.2107C217.466 81.1045 217.32 80.9917 217.18 80.8789C216.583 80.401 216.012 79.9298 215.481 79.4917C210.205 75.0449 207.909 72.191 207.909 72.191C204.842 75.3171 199.765 72.6954 200.654 66.8416C200.833 65.6138 187.686 78.0847 189.239 78.5493C191.654 79.2727 192.763 80.4408 193.115 81.6488C193.679 83.5868 192.292 85.6376 191.157 86.1951C191.157 86.1951 195.623 92.1485 201.875 97.0533C202.353 97.4316 202.838 97.8033 203.342 98.1617C204.099 98.6993 204.909 99.2236 205.751 99.728C211.127 102.914 217.691 105.097 217.691 105.097C219.079 102.967 220.818 102.283 222.337 102.496C223.698 102.681 224.893 103.597 225.503 104.852C225.709 105.27 225.848 105.734 225.915 106.212C225.935 106.398 226.691 105.588 227.78 104.301C230.813 100.717 236.408 93.4826 235.638 94.2126L235.625 94.2193ZM217.273 94.3454C214.997 97.6838 210.079 98.2811 207.086 96.7148C206.82 96.5754 206.568 96.4294 206.329 96.2834C205.506 95.7922 204.802 95.248 204.205 94.6839C200.78 91.4184 201.079 87.2703 203.608 84.8412C203.953 84.5093 204.325 84.1907 204.716 83.8987C207.271 82.0138 210.703 81.1045 213.736 82.4718C214.2 82.6775 214.652 82.943 215.096 83.2483C215.289 83.4009 215.481 83.5602 215.674 83.7195C216.616 84.5359 217.293 85.4584 217.758 86.4141C219.132 89.2282 218.607 92.3742 217.267 94.3387L217.273 94.3454Z",
    fill: "#92EC38"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M226.107 110.852C224.01 112.431 206.674 104.314 205.738 99.7279C204.802 95.1417 215.727 80.5005 218.853 80.8257C221.972 81.1509 239.919 90.4892 239.853 92.2745C239.793 94.0599 231.025 107.148 226.107 110.852Z",
    fill: "#FCFFA1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M242.58 91.1994C243.536 91.5511 227.581 112.537 225.902 112.504C224.899 112.484 214.698 109.856 203.442 102.091C204.099 102.456 221.654 112.59 225.882 110.964C230.196 109.298 241.625 93.7679 240.662 91.956C240.397 91.4781 239.653 90.622 238.671 89.6264C239.985 90.1905 241.299 90.7149 242.58 91.1927V91.1994Z",
    fill: "#FFD885"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M201.278 60.2112C201.856 61.3527 202.553 62.5208 203.402 63.6956C202.466 63.1248 201.623 62.6868 200.999 62.5474C198.59 61.9832 184.473 75.8612 183.763 78.7881C183.033 81.7283 193.493 93.894 193.493 93.894L193.433 93.8608C189.398 89.8852 185.522 85.1663 182.203 79.5448C181.653 78.5957 201.013 59.7067 201.278 60.2112Z",
    fill: "#FFD885"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M200.515 97.9559C197.19 98.7524 183.372 83.3943 185.449 78.536C187.533 73.6777 198.351 64.074 201.252 65.1691C204.152 66.2642 216.198 77.8723 215.442 79.7639C214.685 81.6554 203.03 97.3519 200.515 97.9559Z",
    fill: "#912774"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M243.735 99.9072C243.735 99.9935 243.729 100.066 243.722 100.113C243.722 100.146 243.716 100.159 243.709 100.173C243.092 101.394 241.778 103.259 240.145 105.376C239.833 105.774 239.514 106.186 239.196 106.597C239.083 106.737 238.97 106.876 238.864 107.015C238.638 107.288 238.419 107.573 238.194 107.852C238.054 108.011 237.921 108.184 237.782 108.343C237.775 108.349 237.782 108.349 237.782 108.349C237.649 108.502 237.53 108.668 237.397 108.814C237.198 109.06 236.999 109.305 236.793 109.544H236.786C236.554 109.836 236.315 110.122 236.083 110.4C235.718 110.825 235.366 111.25 235.021 111.668C234.988 111.701 234.961 111.728 234.935 111.761C234.523 112.245 234.118 112.717 233.714 113.188C233.203 113.765 232.718 114.329 232.247 114.867C231.802 115.378 231.377 115.856 230.972 116.307C230.86 116.42 230.753 116.533 230.674 116.639C230.468 116.865 230.276 117.07 230.096 117.283C229.851 117.548 229.619 117.794 229.4 118.033C229.028 118.444 228.689 118.803 228.397 119.115C228.218 119.294 228.065 119.453 227.926 119.593C227.846 119.586 227.767 119.546 227.7 119.513C227.528 119.427 227.448 119.228 227.435 118.942C227.302 116.46 232.333 107.042 236.149 101.573C237.211 100.047 238.187 98.8187 238.93 98.1484C240.39 96.821 242.016 96.6816 243.45 97.0068H243.457C243.516 97.4515 243.57 97.8895 243.609 98.2745C243.616 98.3077 243.616 98.3342 243.623 98.3608C243.629 98.467 243.643 98.5665 243.656 98.6594C243.669 98.7988 243.676 98.9315 243.696 99.051C243.729 99.4227 243.742 99.7081 243.735 99.9072Z",
    fill: "url(#paint21_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M243.735 99.9071C243.735 99.9934 243.728 100.066 243.722 100.113C243.722 100.146 243.715 100.159 243.709 100.173C243.091 101.394 241.777 103.259 240.144 105.376C239.833 105.774 239.514 106.186 239.195 106.597C239.083 106.737 238.97 106.876 238.864 107.015C238.638 107.287 238.419 107.573 238.193 107.852C238.054 108.011 237.921 108.183 237.782 108.343C237.775 108.349 237.782 108.349 237.782 108.349C237.649 108.502 237.529 108.668 237.397 108.814C237.198 109.06 236.999 109.305 236.793 109.544H236.786C236.554 109.836 236.315 110.122 236.083 110.4C235.718 110.825 235.366 111.25 235.021 111.668C234.987 111.701 234.961 111.728 234.934 111.761C234.523 112.245 234.118 112.717 233.713 113.188C233.202 113.765 232.718 114.329 232.246 114.867C231.802 115.378 231.377 115.856 230.972 116.307C230.859 116.42 230.753 116.533 230.673 116.639C230.468 116.865 230.275 117.07 230.096 117.283C229.85 117.548 229.618 117.794 229.399 118.033C229.027 118.444 228.689 118.803 228.397 119.115C228.218 119.294 228.065 119.453 227.926 119.593C227.839 119.679 227.766 119.752 227.7 119.825C227.362 120.163 227.149 120.342 227.096 120.342C226.081 120.289 217.054 118.431 206.827 112.564C199.148 108.164 190.785 101.507 184.606 91.6507C185.588 92.9648 194.336 104.453 206.847 112.172C212.767 115.823 219.523 118.624 226.698 119.101H226.711C226.917 119.115 227.156 119.062 227.428 118.949C229.651 118.006 233.687 112.995 237.602 107.52C239.766 104.513 241.877 101.361 243.642 98.6727C243.642 98.6727 243.644 98.6682 243.649 98.6594C243.649 98.6594 243.655 98.6527 243.655 98.6461C243.669 98.7921 243.675 98.9315 243.689 99.0576C243.722 99.4293 243.735 99.7147 243.728 99.9138L243.735 99.9071Z",
    fill: "url(#paint22_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M226.094 109.571C220.054 111.94 221.382 85.7637 228.941 86.6597C236.501 87.5557 238.917 91.9892 238.552 93.5755C238.187 95.1684 231.384 107.487 226.087 109.564L226.094 109.571Z",
    fill: "#FCFFA1"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M243.735 99.9071C243.735 99.708 243.729 99.4226 243.696 99.0509C243.689 98.9248 243.682 98.7854 243.662 98.6394C243.649 98.5465 243.629 98.4536 243.623 98.354C243.616 98.3341 243.616 98.3009 243.609 98.2678C243.569 97.8828 243.516 97.4514 243.457 97.0001C243.437 96.8408 243.41 96.6749 243.39 96.5089C243.384 96.4758 243.377 96.4492 243.377 96.416C243.317 95.9514 243.244 95.4669 243.178 95.0023C243.165 94.8762 243.138 94.7568 243.125 94.6307C243.085 94.3652 243.045 94.1064 243.012 93.8541C242.979 93.6218 242.946 93.3962 242.912 93.1904C242.866 92.8785 242.819 92.5931 242.78 92.3475C242.766 92.2546 242.746 92.1617 242.733 92.0754C242.713 91.9029 242.687 91.7502 242.667 91.6175C242.654 91.5378 242.647 91.4715 242.634 91.4184C242.627 91.4051 242.627 91.3852 242.627 91.3719C242.627 91.3719 242.62 91.3653 242.627 91.3653V91.3387C242.627 91.2723 242.627 91.2259 242.6 91.2126V91.1993H242.587C241.313 90.7148 239.999 90.1972 238.685 89.633C224.999 83.7128 210.185 73.2595 203.416 63.6956C202.566 62.5208 201.869 61.3527 201.292 60.2111C201.026 59.7134 181.666 78.5957 182.217 79.5448C182.217 79.5448 182.104 87.1906 182.277 87.5424C182.993 88.9229 183.743 90.2503 184.54 91.5179C184.54 91.5179 184.546 91.5246 184.573 91.571C184.586 91.5909 184.606 91.6175 184.626 91.6507C190.799 101.507 199.168 108.164 206.847 112.564C217.074 118.431 226.094 120.289 227.116 120.342C227.169 120.342 227.382 120.163 227.72 119.825C227.913 119.639 228.145 119.4 228.417 119.115C228.716 118.803 229.061 118.444 229.419 118.033C229.638 117.794 229.864 117.548 230.116 117.283C230.295 117.077 230.488 116.865 230.694 116.639C230.78 116.533 230.879 116.42 230.992 116.307C231.404 115.849 231.829 115.365 232.267 114.867C232.738 114.329 233.222 113.765 233.733 113.188C234.132 112.717 234.543 112.245 234.955 111.761C234.974 111.728 235.008 111.701 235.041 111.668C235.386 111.25 235.744 110.825 236.103 110.4C236.335 110.121 236.574 109.836 236.806 109.551H236.813C237.012 109.305 237.211 109.06 237.417 108.807C237.55 108.661 237.669 108.495 237.802 108.343C237.802 108.343 237.795 108.343 237.802 108.336C237.941 108.177 238.074 108.004 238.213 107.845C238.439 107.566 238.658 107.281 238.884 107.009C238.99 106.869 239.103 106.73 239.216 106.591C239.534 106.179 239.859 105.774 240.165 105.369C241.804 103.252 243.111 101.387 243.729 100.166C243.735 100.153 243.742 100.133 243.742 100.106C243.749 100.06 243.755 99.9867 243.755 99.9005L243.735 99.9071Z",
    fill: "url(#paint23_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M237.855 108.343V108.349C237.722 108.502 237.603 108.668 237.47 108.814C237.271 109.06 237.072 109.305 236.866 109.544H236.859C236.627 109.836 236.388 110.122 236.156 110.4C235.791 110.825 235.439 111.25 235.094 111.668C235.061 111.701 235.034 111.728 235.008 111.761C234.596 112.245 234.191 112.717 233.786 113.188C233.275 113.765 232.791 114.329 232.32 114.867C231.882 115.371 231.457 115.856 231.045 116.307C230.933 116.42 230.826 116.533 230.747 116.639C230.548 116.865 230.355 117.07 230.169 117.283C229.924 117.548 229.691 117.794 229.472 118.033C229.107 118.444 228.769 118.803 228.47 119.115C228.198 119.4 227.966 119.639 227.773 119.825C227.435 120.163 227.222 120.343 227.169 120.343C226.154 120.289 217.128 118.431 206.9 112.564C206.9 112.431 206.907 112.298 206.92 112.172C207.072 109.299 207.431 105.588 208.048 105.004C208.068 104.971 208.108 104.951 208.141 104.938C208.254 104.892 208.393 104.878 208.579 104.878C209.156 104.878 210.086 105.057 211.393 105.25C213.603 105.575 216.862 105.934 221.309 105.529C221.767 105.482 222.211 105.436 222.656 105.376C223.652 105.243 224.614 105.077 225.55 104.872C226.34 104.699 227.103 104.52 227.826 104.314C230.09 103.697 232.034 102.967 233.455 102.356H233.461C233.521 102.323 233.587 102.296 233.64 102.27C233.74 102.223 233.84 102.184 233.932 102.144C234.543 101.865 235.034 101.626 235.386 101.44C235.764 101.248 235.97 101.115 236.003 101.075C236.023 101.042 236.103 101.228 236.209 101.58C236.534 102.615 237.171 105.097 237.669 107.52C237.729 107.799 237.782 108.077 237.842 108.343H237.855Z",
    fill: "url(#paint24_linear_122_3078)"
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M235.824 75.2706C235.824 75.2706 233.866 64.4655 230.839 56.8728C227.813 49.28 217.784 34.1676 217.572 33.5238C217.36 32.88 239.567 17.4888 241.625 17.0109C243.682 16.533 253.359 14.5685 254.587 15.0862C255.815 15.6038 267.19 32.8733 267.92 46.373C268.299 53.395 235.83 75.2706 235.83 75.2706H235.824Z",
    fill: "#D1FF86"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M242.421 80.474C242.421 80.474 238.87 78.4828 235.831 75.2705C235.413 74.8259 235.565 56.9789 219.351 33.3047C219.099 32.9264 228.351 26.7075 234.941 22.3205C234.968 22.2939 234.988 22.2873 234.988 22.2873C238.247 20.0904 240.848 18.3847 241.286 18.0662C241.771 17.7343 253.479 16.4998 253.479 16.4998C253.479 16.4998 255.596 29.0172 254.554 43.9638C253.698 56.3949 250.658 70.5052 242.415 80.4607L242.421 80.474Z",
    fill: "#2E8F46"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M242.421 80.474C242.421 80.474 241.273 79.8302 239.713 78.6886C238.538 77.8059 237.145 76.6444 235.83 75.2705C235.485 74.9055 235.532 62.6669 226.413 45.0987C224.501 41.3753 222.172 37.433 219.357 33.3114C219.762 33.1189 225.225 33.61 226.625 34.4397L254.56 43.9771C253.704 56.4082 250.664 70.5185 242.421 80.474Z",
    fill: "url(#paint25_linear_122_3078)"
  }), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M269.089 75.2905C267.303 76.1798 263.971 77.0825 260.261 77.8855C259.757 77.9917 259.253 78.0913 258.742 78.2041C251.122 79.7373 242.574 80.8058 242.428 80.4806C242.341 80.2881 242.322 78.5293 242.01 75.629C242.01 75.6157 242.003 75.5891 242.01 75.5759C241.339 69.1911 239.395 57.3174 232.778 44.5346C232.771 44.4947 232.744 44.4682 232.738 44.4483C232.724 44.4284 232.705 44.3952 232.691 44.3554C232.678 44.3155 232.651 44.2757 232.632 44.2293C232.585 44.1363 232.532 44.0501 232.486 43.9571C230.826 40.8112 228.895 37.6122 226.618 34.4397C226.054 33.6432 252.894 16.5065 253.478 16.5065H253.485C255.211 18.2653 256.764 20.1436 258.138 22.0948C258.37 22.42 258.595 22.7453 258.815 23.0771C258.967 23.3094 259.126 23.5417 259.279 23.7806C259.339 23.8736 259.405 23.9731 259.465 24.066C259.465 24.0727 259.465 24.0793 259.472 24.0793C259.511 24.1324 259.538 24.1921 259.578 24.2519C259.618 24.285 259.631 24.305 259.631 24.305C263.109 29.8004 265.432 35.7803 266.971 41.6607C267.92 45.3045 268.571 48.9084 268.982 52.333C268.982 52.333 268.982 52.4127 268.989 52.5322C269.049 53.0167 269.102 53.4945 269.148 53.9724C270.436 65.9787 269.082 75.2905 269.082 75.2905H269.089Z",
    fill: "url(#paint26_linear_122_3078)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.8
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M267.436 63.7819C267.436 63.7819 267.562 60.2776 267.277 55.8308C267.057 52.4924 266.613 48.623 265.697 45.3178C265.657 45.1917 265.631 45.0656 265.591 44.9395C265.504 44.6275 265.412 44.3288 265.319 44.0302C264.814 42.351 264.23 40.7183 263.62 39.1785C263.54 38.9861 263.467 38.7936 263.387 38.6077C260.719 32.0371 257.606 27.1855 257.606 27.1855C257.009 27.7562 255.867 28.2142 254.64 28.2606C254.527 28.2673 254.407 28.2739 254.295 28.2606C252.071 28.2142 249.742 26.7275 250.047 21.9887C250.14 20.6679 241.1 26.5284 236.222 30.2053C236.209 30.2186 236.189 30.2385 236.175 30.2451C234.138 31.7982 232.844 32.953 233.255 33.0393C233.275 33.0459 233.308 33.0459 233.335 33.0526C237.363 33.922 239.288 36.1919 239.321 38.7869C239.328 39.0325 239.321 39.2914 239.288 39.5369C239.116 41.017 238.359 42.5767 237.065 44.0036C237.065 44.0036 238.664 46.5722 240.921 52.5787C241.425 53.8928 241.95 55.3728 242.494 57.0254C245.129 64.9235 244.691 72.4631 244.691 72.4631C246.35 70.8039 247.638 70.2663 248.567 70.3924H248.573C250.963 70.7242 250.936 75.4631 248.567 76.9166C247.764 77.421 253.399 76.2927 258.343 75.1511C258.967 75.0051 259.584 74.8591 260.182 74.7197C263.201 73.9897 265.551 73.3392 265.285 73.1998C261.648 71.295 261.064 65.2222 267.423 63.7952L267.436 63.7819ZM259.777 56.6604C258.728 57.7489 257.407 58.5851 255.861 58.9635C254.799 59.2289 253.584 59.2754 252.35 59.063C249.416 58.5851 246.37 56.687 244.936 52.9105C244.379 51.4238 244.233 49.9769 244.412 48.6097C244.764 45.9416 246.343 43.5855 248.427 41.8864C249.237 41.2161 250.133 40.6519 251.062 40.2073C252.038 39.736 253.073 39.4905 254.129 39.4772C254.348 39.4706 254.567 39.4772 254.786 39.4905C255.848 39.5701 256.903 39.8887 257.872 40.4661C260.162 41.8068 262.04 44.5479 262.597 48.8287C262.597 48.8619 262.604 48.8818 262.604 48.915C262.664 49.4261 262.664 49.957 262.617 50.4946C262.431 52.6649 261.429 54.968 259.783 56.6604H259.777Z",
    fill: "#92EC38"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M232.738 44.4417C231.025 41.1431 229.014 37.7781 226.618 34.4397C226.041 33.6366 253.259 16.2676 253.478 16.5131C255.841 18.9091 257.852 21.5241 259.578 24.2519C259.173 23.6346 255.582 18.4445 253.253 17.9666C250.77 17.4755 229.638 32.0504 229.187 34.3932C228.775 36.5901 232.299 43.5789 232.731 44.4483L232.738 44.4417Z",
    fill: "#FFD885"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M269.089 75.2905C267.303 76.1798 263.972 77.0825 260.262 77.8856C259.757 77.9917 259.253 78.0913 258.742 78.2041C251.122 79.7373 242.574 80.8058 242.428 80.4806C242.342 80.2882 242.322 78.5293 242.01 75.629C242.514 76.9232 243.092 78.0316 243.729 78.4895C243.775 78.5227 243.828 78.5493 243.888 78.5824C244.233 78.7417 244.83 78.8612 245.607 78.9143C248.481 79.14 253.89 78.6886 258.689 77.8524C259.213 77.7595 259.731 77.6665 260.235 77.567C263.952 76.8236 267.058 75.848 267.927 74.7728C269.912 72.3237 269.348 58.8307 269.082 54.0454C269.042 53.3286 269.002 52.8043 268.989 52.5388C269.049 53.0233 269.102 53.5012 269.148 53.979C270.436 65.9854 269.082 75.2971 269.082 75.2971L269.089 75.2905Z",
    fill: "#FFD885"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M265.77 40.174C263.009 35.714 242.242 47.2292 240.324 53.9591C238.406 60.689 243.463 78.7483 245.613 78.9209C247.764 79.0934 265.584 77.6599 268 71.0295C270.416 64.3991 269.274 45.8288 265.77 40.174Z",
    fill: "#FCFFA1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M265.465 42.6497C264.748 37.6189 256.465 31.4531 252.715 42.5435C248.965 53.6406 267.283 55.426 265.465 42.6497Z",
    fill: "#FCFFA1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M266.938 56.5011C267.509 53.1096 262.212 50.8198 261.423 54.7688C260.633 58.7178 266.088 61.5187 266.938 56.5011Z",
    fill: "#FCFFA1"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M239.713 78.6953C238.538 77.8126 237.145 76.6511 235.831 75.2772C235.485 74.9122 235.532 62.6736 226.413 45.1054C226.525 45.0789 226.618 45.0656 226.731 45.0523C229.26 44.9793 241.485 61.4988 241.027 71.3747C240.875 74.6003 240.364 76.9697 239.72 78.6953H239.713Z",
    fill: "url(#paint27_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M235.824 75.2706C235.406 74.8259 235.558 56.979 219.344 33.3047C219.092 32.9264 228.344 26.7076 234.934 22.3205C234.112 22.9046 222.092 31.5725 221.806 33.3977C221.528 35.2627 237.795 63.762 235.817 75.2639L235.824 75.2706Z",
    fill: "url(#paint28_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M252.244 19.3073C255.489 18.8493 255.635 35.1233 249.33 38.1763C243.025 41.2293 230.647 38.9794 231.311 35.9396C231.975 32.8999 247.512 19.971 252.244 19.3073Z",
    fill: "#912774"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M269.155 53.979C269.108 53.5011 269.055 53.0233 268.996 52.5388C268.989 52.4127 268.989 52.3397 268.989 52.3397C268.571 48.915 267.927 45.3111 266.978 41.6674C265.445 35.787 263.122 29.807 259.637 24.3116C259.637 24.3116 259.624 24.2917 259.584 24.2585C259.571 24.2386 259.551 24.212 259.538 24.1855C259.551 24.2054 259.578 24.2386 259.584 24.2585C259.564 24.2319 259.544 24.1987 259.525 24.1722C259.505 24.1457 259.491 24.1125 259.471 24.0859C259.465 24.0859 259.465 24.0793 259.465 24.0726C259.405 23.9797 259.339 23.8802 259.279 23.7873C259.126 23.5483 258.967 23.316 258.814 23.0837C258.675 22.8713 258.529 22.6722 258.383 22.4665C258.303 22.3537 258.224 22.2342 258.144 22.1214V22.1081C257.733 21.5373 257.308 20.9732 256.876 20.4157C256.77 20.2829 256.664 20.1502 256.558 20.0174C256.179 19.5396 255.788 19.0683 255.39 18.6104C255.277 18.4776 255.164 18.3449 255.051 18.2188C254.547 17.648 254.029 17.0772 253.485 16.5264H253.478H253.465C252.994 16.5728 241.764 17.7609 241.293 18.0861C240.855 18.4046 238.26 20.1104 234.994 22.3072C234.994 22.3072 234.974 22.3138 234.948 22.3404C228.357 26.7208 219.105 32.9463 219.357 33.3246C219.802 33.9751 220.227 34.6122 220.645 35.2494C220.784 35.4551 220.917 35.6675 221.05 35.8733C221.355 36.3378 221.647 36.8024 221.939 37.267C222.059 37.4595 222.185 37.652 222.298 37.8378C222.643 38.3887 222.975 38.9395 223.3 39.4838C223.512 39.8422 223.718 40.1939 223.924 40.5457C224.023 40.7116 224.116 40.8776 224.209 41.0435C224.999 42.424 225.736 43.7779 226.412 45.1053C231.218 54.364 233.481 62.1492 234.589 67.4853C234.603 67.5517 234.616 67.6247 234.629 67.6911C234.682 67.9433 234.729 68.1888 234.775 68.4278C234.788 68.5074 234.808 68.5871 234.822 68.6667C234.868 68.899 234.908 69.1247 234.948 69.3503C234.961 69.4167 234.974 69.4831 234.981 69.5494C235.107 70.253 235.207 70.8967 235.293 71.4808C235.306 71.5538 235.313 71.6268 235.326 71.6998C235.346 71.8591 235.372 72.0051 235.392 72.1578C235.406 72.2441 235.412 72.3237 235.426 72.4033C235.445 72.5427 235.459 72.6755 235.479 72.8016C235.485 72.8679 235.499 72.9409 235.505 73.0073C235.591 73.7175 235.651 74.2683 235.704 74.6533L235.718 74.7396C235.724 74.8126 235.737 74.8789 235.744 74.9387C235.744 74.9652 235.751 74.9918 235.757 75.0183C235.764 75.0714 235.777 75.1112 235.784 75.1444C235.784 75.1577 235.791 75.1776 235.797 75.1909C235.81 75.2307 235.824 75.2639 235.83 75.2772C236.474 75.9608 237.145 76.5847 237.795 77.1488C237.822 77.1687 237.848 77.1953 237.875 77.2152C238.12 77.4209 238.359 77.6267 238.591 77.8125C238.976 78.1311 239.355 78.4298 239.713 78.6952C240.755 79.4585 241.598 79.9894 242.056 80.2616L242.122 80.3014C242.169 80.3279 242.209 80.3545 242.248 80.3744C242.288 80.4009 242.321 80.4142 242.348 80.4341L242.374 80.4474L242.421 80.474C242.567 80.7992 251.115 79.7372 258.735 78.2041C259.246 78.0979 259.75 77.9983 260.255 77.8855C263.965 77.0824 267.303 76.1798 269.082 75.2904C269.082 75.2904 270.442 65.9854 269.148 53.9724L269.155 53.979Z",
    fill: "url(#paint29_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M269.088 75.2905C267.303 76.1798 263.971 77.0824 260.261 77.8855C260.255 77.786 260.248 77.6798 260.241 77.5603C260.228 77.2484 260.208 76.9165 260.195 76.5515C260.182 75.994 260.182 75.3767 260.201 74.7064C260.308 70.6578 261.177 64.6712 264.695 59.1957C265.358 58.1603 266.115 57.1449 266.984 56.1626C267.077 56.0564 267.177 55.9369 267.276 55.8307C267.814 55.2334 268.398 54.656 269.022 54.1051C269.042 54.0852 269.068 54.0587 269.088 54.0454C269.108 54.0122 269.135 53.9989 269.155 53.9857C270.442 65.992 269.088 75.3037 269.088 75.3037V75.2905Z",
    fill: "url(#paint30_linear_122_3078)"
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M260.806 81.2107C260.806 81.2107 263.772 68.9521 275.965 52.6848C285.383 40.121 301.066 32.9994 302.26 32.8667C303.462 32.7406 312.621 40.4329 313.218 41.2028C313.815 41.9727 320.598 69.4632 309.88 75.6356C299.161 81.808 260.806 81.204 260.806 81.204V81.2107Z",
    fill: "#D1FF86"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M326.426 65.5474C325.861 65.8593 325.297 66.1712 324.753 66.4898C324.202 66.8018 323.665 67.1137 323.134 67.4323C322.669 67.7044 322.204 67.9831 321.753 68.2553C321.169 68.6203 320.598 68.9721 320.034 69.3371C319.53 69.649 319.039 69.9676 318.554 70.2862C318.541 70.2928 318.521 70.2995 318.514 70.3061C317.061 71.2552 315.687 72.2043 314.386 73.1534C310.888 75.6821 307.882 78.1776 305.3 80.5536C304.431 81.3501 303.608 82.1332 302.838 82.9098C302.665 83.0691 302.499 83.235 302.333 83.4142C302.161 83.5735 302.001 83.746 301.842 83.9186C300.986 84.7814 300.203 85.6243 299.473 86.434C299.094 86.8588 298.723 87.2769 298.378 87.6751C297.993 88.1132 297.628 88.5446 297.289 88.9627C297.163 89.1087 297.057 89.2481 296.951 89.3809C296.612 89.7924 296.294 90.1906 296.002 90.5689C295.802 90.8211 295.61 91.0733 295.431 91.3122C295.391 91.3587 295.364 91.3985 295.331 91.445C295.179 91.6441 295.033 91.8366 294.9 92.0224C294.814 92.1352 294.727 92.2481 294.654 92.3542C294.495 92.5799 294.336 92.7923 294.19 92.998C293.964 93.3166 293.758 93.602 293.572 93.8808C293.307 94.2524 293.088 94.5909 292.889 94.8896C292.789 95.0356 292.69 95.1816 292.603 95.3144C292.51 95.4471 292.431 95.5798 292.358 95.6927L292.345 95.7059C292.278 95.8121 292.205 95.9117 292.152 96.0046C292.046 96.1572 291.96 96.29 291.887 96.3962C291.84 96.4559 291.8 96.5024 291.774 96.5488C291.707 96.6418 291.648 96.7015 291.621 96.7081C291.389 96.7944 291.157 96.8674 290.924 96.9471C290.46 97.0931 290.008 97.2324 289.557 97.3585C289.338 97.4116 289.126 97.4714 288.913 97.5311C288.25 97.7037 287.619 97.8431 287.022 97.9492C286.823 97.9891 286.623 98.0156 286.424 98.0488C285.966 98.1351 285.542 98.1948 285.157 98.2479C284.918 98.2811 284.692 98.3076 284.493 98.3342C284.46 98.3408 284.433 98.3408 284.407 98.3408C284.261 98.3541 284.128 98.374 284.008 98.3873C283.743 98.4072 283.531 98.4271 283.378 98.4404C283.338 98.4404 283.312 98.4404 283.278 98.447C283.152 98.4537 283.086 98.4537 283.086 98.4537C282.9 97.6506 282.747 96.8409 282.615 96.0245C282.555 95.6727 282.502 95.3144 282.455 94.9626C282.057 92.0888 281.951 89.1751 282.084 86.2482C282.13 85.2394 282.197 84.2239 282.309 83.2151C282.608 80.1289 283.159 77.0427 283.876 74.0095C284.646 70.7906 285.615 67.6247 286.703 64.585C287.38 62.6735 288.117 60.8085 288.873 59.0033C289.159 58.3197 289.451 57.6427 289.743 56.979C290.075 56.2224 290.413 55.4724 290.752 54.7423C290.898 54.4237 291.05 54.0985 291.196 53.7866C292.849 50.3088 294.548 47.1429 296.114 44.4085C296.698 43.3798 297.269 42.4107 297.813 41.5148C298.285 40.7449 298.729 40.0148 299.141 39.3444C300.203 37.6719 301.086 36.3512 301.703 35.4485C302.274 34.6255 302.619 34.141 302.665 34.0813H302.672C302.672 34.0813 312.946 40.6719 313.231 41.2094C313.497 41.7006 315.096 44.4948 317.101 48.0456C317.101 48.0456 317.114 48.0588 317.121 48.0987C317.16 48.165 317.2 48.2314 317.227 48.2978C321.275 55.4126 326.844 65.3018 326.432 65.5407L326.426 65.5474Z",
    fill: "#2E8F46"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M326.426 65.5474C325.861 65.8593 325.297 66.1713 324.753 66.4898C324.202 66.8018 323.665 67.1137 323.134 67.4323C322.662 67.7111 322.204 67.9832 321.753 68.2553C321.169 68.6203 320.598 68.9721 320.034 69.3371C319.53 69.6557 319.039 69.9676 318.554 70.2862C318.541 70.2928 318.521 70.2995 318.514 70.3061C317.074 71.2619 315.707 72.2109 314.399 73.16C310.902 75.6821 307.895 78.1842 305.313 80.5537C305.307 80.5603 305.307 80.5537 305.307 80.5537C304.437 81.3567 303.608 82.1465 302.838 82.9098C302.665 83.0691 302.499 83.235 302.333 83.4142C302.161 83.5868 302.001 83.7527 301.842 83.9186C300.986 84.7814 300.203 85.6243 299.473 86.4341C299.094 86.8588 298.729 87.277 298.378 87.6752C297.993 88.1132 297.628 88.5446 297.289 88.9628C297.176 89.1021 297.057 89.2415 296.951 89.3809C296.612 89.7924 296.294 90.1906 296.002 90.5689C295.809 90.8211 295.617 91.0733 295.431 91.3123C295.391 91.3587 295.364 91.3985 295.331 91.445C295.185 91.6441 295.039 91.8299 294.9 92.0224C294.814 92.1353 294.727 92.2481 294.654 92.3543C294.495 92.5799 294.336 92.7923 294.19 92.9981C293.964 93.3166 293.758 93.602 293.572 93.8808C293.32 94.2525 293.088 94.5909 292.889 94.8896C292.789 95.0356 292.69 95.1816 292.603 95.3144C292.51 95.4471 292.431 95.5799 292.358 95.6927L292.345 95.706C292.285 95.8121 292.212 95.9117 292.152 96.0046C292.046 96.1573 291.96 96.29 291.887 96.3962C291.84 96.4559 291.8 96.509 291.774 96.5489C291.707 96.6418 291.648 96.7015 291.621 96.7081C291.389 96.7944 291.157 96.8674 290.924 96.9471C290.46 97.0931 290.008 97.2325 289.557 97.3586C289.338 97.4117 289.126 97.4714 288.913 97.5311C288.25 97.7037 287.619 97.8431 287.022 97.9493C286.816 97.9957 286.623 98.0355 286.424 98.0621C285.966 98.1417 285.535 98.2015 285.157 98.2479C284.918 98.2878 284.692 98.3077 284.493 98.3342C284.46 98.3409 284.433 98.3409 284.407 98.3409C284.261 98.3541 284.128 98.374 284.008 98.3873C283.743 98.4072 283.531 98.4271 283.378 98.4404C283.338 98.4404 283.312 98.4404 283.278 98.447C283.152 98.4537 283.086 98.4537 283.086 98.4537C282.9 97.6506 282.747 96.8409 282.615 96.0245C282.555 95.6728 282.502 95.3144 282.455 94.9626C282.057 92.0888 281.951 89.1751 282.084 86.2482C282.13 85.2394 282.197 84.2239 282.309 83.2151C282.608 80.1289 283.159 77.0427 283.876 74.0096C284.646 70.7906 285.615 67.6248 286.703 64.585C287.38 62.6736 288.117 60.8086 288.873 59.0033L291.103 59.3152L291.442 59.3617L295.524 59.9258L302.685 60.9214L305.4 61.2997L314.107 62.501L316.384 62.8196L319.185 63.2045C320.174 63.1381 322.39 63.8218 324.116 64.4788C325.344 64.9501 326.326 65.3947 326.439 65.554L326.426 65.5474Z",
    fill: "url(#paint31_linear_122_3078)"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M319.171 63.1979C315.435 65.1492 312.03 67.3062 308.937 69.5362L308.844 69.6026C308.844 69.6026 308.791 69.6358 308.764 69.6623C304.789 72.5428 301.331 75.556 298.351 78.5227C292.252 84.5558 288.157 90.3432 285.741 94.1064C285.734 94.1197 285.721 94.1396 285.721 94.1529C284.081 96.6949 283.239 98.3143 283.073 98.4537C282.615 98.8187 264.675 86.4141 260.799 81.2107C260.799 81.2107 261.383 79.4519 262.611 76.5847C264.31 72.6357 267.217 66.5828 271.491 60.1847C271.551 60.0718 271.591 60.0055 271.591 60.0055C276.774 52.2468 283.955 44.0302 293.32 38.4086C293.32 38.4086 293.34 38.3954 293.387 38.3887C293.426 38.3688 293.479 38.3356 293.546 38.2958C296.373 36.6167 299.386 35.1698 302.639 34.0747H302.645C302.964 33.9419 320.054 62.7134 319.151 63.1912L319.171 63.1979Z",
    fill: "url(#paint32_linear_122_3078)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.8
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M312.289 54.875C309.501 49.1871 303.82 39.4705 303.289 40.7448C301.364 45.2646 298.51 45.5633 296.433 44.581C296.32 44.5279 296.207 44.4748 296.101 44.4085C295 43.7912 294.157 42.8355 293.865 42.0324C293.865 42.0324 288.714 45.0788 283.179 49.9172C283.02 50.0566 282.86 50.1959 282.701 50.3353C281.188 51.6826 279.661 53.1627 278.208 54.7423C278.108 54.8419 278.015 54.948 277.922 55.0542C272.361 61.2067 267.701 71.3282 267.701 71.3282C271.591 74.5339 270.701 78.317 268.232 80.0625C267.39 80.6598 266.367 81.0182 265.286 81.0381C264.443 81.0448 279.947 93.7613 279.031 92.2746C277.511 89.8255 279.708 85.4053 282.071 86.2482C282.987 86.5668 283.929 87.6685 284.692 89.9649C284.692 89.9649 286.225 86.4207 289.259 82.2062C290.539 80.4142 292.099 78.5094 293.918 76.6975C295.199 75.4166 296.38 74.2883 297.455 73.3126C302.347 68.8128 305.028 67.1801 305.028 67.1801C304.497 65.2487 304.524 63.4633 305.061 62.0098C305.148 61.7643 305.254 61.5253 305.386 61.2997C306.621 58.917 309.462 57.709 313.596 58.7909C313.616 58.7909 313.65 58.7975 313.676 58.8041C314.101 58.9103 313.444 57.2444 312.289 54.875ZM293.606 71.753C290.52 74.587 286.809 74.9254 283.869 74.0095C282.635 73.618 281.533 73.0073 280.664 72.264C277.478 69.5296 276.98 64.7376 278.374 61.2997C278.593 60.7422 278.858 60.2178 279.177 59.7466C281.686 56.0431 284.692 54.3773 287.453 54.2113C288.621 54.1251 289.73 54.3175 290.752 54.7423C290.971 54.8286 291.177 54.9281 291.376 55.0277C292.331 55.5387 293.188 56.2555 293.871 57.1449C294.522 57.9878 295.086 58.9303 295.524 59.9258C296.665 62.4744 297.03 65.3881 296.101 68.0296C295.63 69.3703 294.82 70.6379 293.619 71.7596L293.606 71.753Z",
    fill: "#92EC38"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M308.844 69.6092C311.964 67.3526 315.402 65.1757 319.171 63.2045C320.081 62.7266 302.977 33.9552 302.665 34.0813C299.36 35.2029 296.28 36.683 293.406 38.402C294.07 38.0237 299.811 34.891 302.194 35.5282C304.723 36.2317 317.492 59.5807 316.815 61.9567C316.171 64.1868 309.647 69.0052 308.844 69.6092Z",
    fill: "#FFD885"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M285.728 94.153C284.088 96.6949 283.245 98.3144 283.079 98.4538C282.622 98.8188 264.682 86.4142 260.806 81.2108C260.806 81.2108 261.39 79.452 262.618 76.5848C264.317 72.6358 267.224 66.5828 271.498 60.1848C270.695 61.552 265.246 70.8703 263.016 76.8901C262.306 78.7949 261.921 80.3812 262.113 81.2573C262.837 84.5691 275.387 93.2171 280.737 95.4671C280.776 95.4804 280.816 95.5003 280.843 95.5136C281.599 95.8321 282.21 96.0047 282.602 96.018C282.668 96.018 282.734 96.0113 282.787 96.0047C283.597 95.872 284.646 95.1153 285.721 94.153H285.728Z",
    fill: "#FFD885"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M280.252 50.2491C284.891 47.4085 298.743 67.7509 297.382 74.879C296.022 82.0005 282.92 96.363 280.843 95.5201C278.765 94.6772 262.943 85.0403 263.799 77.7794C264.655 70.5185 274.365 53.853 280.252 50.2491Z",
    fill: "#FCFFA1"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M305.307 80.5602C304.438 81.3633 303.608 82.1531 302.838 82.9164C302.665 83.0757 302.5 83.2416 302.334 83.4208C302.161 83.5933 302.002 83.7593 301.842 83.9252C300.986 84.788 300.203 85.6309 299.473 86.4406C299.095 86.8654 298.73 87.2835 298.378 87.6818C297.993 88.1198 297.628 88.5512 297.29 88.9693C297.177 89.1087 297.057 89.2481 296.951 89.3875C296.613 89.799 296.294 90.1972 296.002 90.5755C295.809 90.8277 295.617 91.0799 295.431 91.3188C295.391 91.3653 295.365 91.4051 295.332 91.4516C295.186 91.6507 295.04 91.8365 294.9 92.029C294.814 92.1418 294.728 92.2546 294.655 92.3608C294.495 92.5865 294.336 92.7989 294.19 93.0046C293.964 93.3232 293.759 93.6086 293.573 93.8874C293.321 94.259 293.088 94.5975 292.889 94.8962C292.79 95.0422 292.69 95.1882 292.604 95.3209C292.511 95.4537 292.431 95.5864 292.358 95.6993L292.345 95.7125C292.285 95.8187 292.212 95.9183 292.152 96.0112C292.046 96.1638 291.96 96.2966 291.887 96.4028C291.841 96.4625 291.801 96.5156 291.774 96.5554C291.708 96.6483 291.648 96.7081 291.621 96.7147C291.389 96.801 291.157 96.874 290.925 96.9537C290.46 97.0997 290.009 97.239 289.557 97.3651C289.338 97.4182 289.126 97.478 288.914 97.5377C288.25 97.7103 287.619 97.8496 287.022 97.9558C286.816 98.0023 286.624 98.0421 286.425 98.0687C285.967 98.1483 285.535 98.208 285.157 98.2545C284.918 98.2943 284.692 98.3142 284.493 98.3408C284.46 98.3474 284.434 98.3474 284.407 98.3474C284.261 98.3607 284.128 98.3806 284.009 98.3939C283.743 98.4138 283.531 98.4337 283.378 98.447C283.339 98.447 283.312 98.447 283.279 98.4536C283.153 98.4603 283.086 98.4603 283.086 98.4603C282.628 98.8253 264.689 86.4207 260.812 81.2173C260.812 81.2173 261.397 79.4585 262.624 76.5913C262.757 76.6909 262.89 76.7904 263.023 76.9032C263.275 77.0957 263.554 77.2948 263.859 77.5006C265.014 78.3169 266.481 79.2196 268.239 80.0691C271.053 81.4363 274.598 82.6443 278.772 83.0757C279.987 83.2018 281.162 83.2482 282.296 83.215C284.858 83.1619 287.195 82.7571 289.265 82.2129C291.641 81.589 293.659 80.7594 295.239 80.0293C296.632 79.3855 297.694 78.828 298.358 78.5293C298.624 78.4165 298.823 78.3368 298.962 78.3236C299.281 78.2837 299.924 78.4497 300.721 78.7085C301.969 79.1333 303.601 79.8103 304.955 80.4076C305.068 80.4607 305.181 80.5071 305.294 80.5602H305.3H305.307Z",
    fill: "url(#paint33_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M279.376 52.6849C282.383 48.3642 292.929 46.5124 291.23 58.5321C289.531 70.5517 271.737 63.6625 279.376 52.6849Z",
    fill: "#FCFFA1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M271.558 64.824C272.606 61.4192 278.58 61.7643 277.471 65.793C276.363 69.8216 270.005 69.8615 271.558 64.824Z",
    fill: "#FCFFA1"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M314.393 73.1666C310.895 75.6887 307.888 78.1909 305.307 80.5603C305.3 80.5669 305.3 80.5603 305.3 80.5603C304.431 81.3634 303.601 82.1532 302.831 82.9164C302.658 83.0757 302.493 83.2416 302.327 83.4208C302.154 83.5934 301.995 83.7593 301.835 83.9252C300.979 84.7881 300.196 85.631 299.466 86.4407C299.088 86.8654 298.723 87.2836 298.371 87.6818C297.986 88.1198 297.621 88.5512 297.283 88.9694C297.17 89.1087 297.05 89.2481 296.944 89.3875C296.606 89.799 296.287 90.1972 295.995 90.5755C295.802 90.8277 295.61 91.0799 295.424 91.3189C295.384 91.3653 295.358 91.4052 295.325 91.4516C295.179 91.6507 295.033 91.8366 294.893 92.029C294.807 92.1419 294.721 92.2547 294.648 92.3609C294.488 92.5865 294.329 92.7989 294.183 93.0047C293.957 93.3232 293.752 93.6086 293.566 93.8874C293.314 94.2591 293.081 94.5976 292.882 94.8962C292.783 95.0422 292.683 95.1882 292.597 95.321C292.504 95.4537 292.424 95.5865 292.351 95.6993L292.338 95.7126C292.278 95.8188 292.205 95.9183 292.145 96.0112C292.039 96.1639 291.953 96.2966 291.88 96.4028C291.834 96.4626 291.794 96.5156 291.767 96.5555C291.701 96.6484 291.641 96.7081 291.615 96.7148C291.382 96.801 291.15 96.874 290.918 96.9537C290.453 97.0997 290.002 97.2391 289.55 97.3652C289.331 97.4183 289.119 97.478 288.907 97.5377C288.243 97.7103 287.612 97.8497 287.015 97.9559C286.809 98.0023 286.617 98.0422 286.418 98.0687V98.0554C286.617 96.1639 287.254 93.7414 288.615 90.6884C290.539 86.3876 295.59 82.0337 300.714 78.7152C306.468 74.9786 312.322 72.5361 313.921 72.9144C314.001 72.9277 314.068 72.9543 314.121 72.9808C314.207 73.0405 314.293 73.087 314.373 73.1666C314.373 73.1666 314.377 73.1689 314.386 73.1733L314.393 73.1666Z",
    fill: "url(#paint34_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M326.426 65.5474C325.862 65.8593 325.298 66.1713 324.753 66.4899C324.202 66.8018 323.665 67.1137 323.134 67.4323C322.669 67.7044 322.205 67.9832 321.753 68.2553C321.169 68.6203 320.599 68.9721 320.034 69.3371C319.53 69.6491 319.039 69.9676 318.554 70.2862C318.541 70.2929 318.521 70.2995 318.515 70.3061C317.061 71.2552 315.687 72.2043 314.386 73.1534C310.889 75.6821 307.882 78.1776 305.3 80.5537C304.431 81.3501 303.608 82.1333 302.838 82.9098C302.665 83.0691 302.499 83.235 302.333 83.4142C302.161 83.5735 302.002 83.7461 301.842 83.9186C300.986 84.7814 300.203 85.6243 299.473 86.4341C299.095 86.8588 298.723 87.277 298.378 87.6752C297.993 88.1132 297.628 88.5446 297.289 88.9628C297.163 89.1088 297.057 89.2482 296.951 89.3809C296.612 89.7924 296.294 90.1906 296.002 90.5689C295.803 90.8211 295.61 91.0733 295.431 91.3123C295.391 91.3587 295.365 91.3985 295.331 91.445C295.179 91.6441 295.033 91.8366 294.9 92.0224C294.814 92.1353 294.727 92.2481 294.654 92.3543C294.495 92.5799 294.336 92.7923 294.19 92.9981C293.964 93.3166 293.758 93.602 293.573 93.8808C293.307 94.2525 293.088 94.591 292.889 94.8896C292.789 95.0356 292.69 95.1816 292.604 95.3144C292.511 95.4471 292.431 95.5799 292.358 95.6927L292.345 95.706C292.278 95.8122 292.205 95.9117 292.152 96.0046C292.046 96.1573 291.96 96.29 291.887 96.3962C291.84 96.4559 291.801 96.5024 291.774 96.5489C291.708 96.6418 291.648 96.7015 291.621 96.7082C293.081 91.9361 298.763 85.9429 304.975 80.401C307.975 77.7263 311.101 75.1578 313.942 72.9012C319.47 68.481 323.89 65.2089 324.123 64.4788C324.66 62.7068 318.242 50.2292 317.24 48.3044C321.289 55.4193 326.857 65.3085 326.446 65.5474H326.426Z",
    fill: "url(#paint35_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M302.506 37.2405C299.712 35.3025 291.993 50.3022 296.407 56.0697C300.82 61.8373 313.331 65.5275 314.134 62.4014C314.937 59.2754 306.581 40.0613 302.506 37.2405Z",
    fill: "#912774"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M317.22 48.3043C317.187 48.238 317.154 48.1716 317.114 48.1052C317.107 48.0654 317.094 48.0521 317.094 48.0521C315.096 44.5013 313.49 41.7071 313.225 41.216C312.939 40.6784 302.665 34.0746 302.665 34.0746C301.391 34.506 300.156 35.0104 298.942 35.5414C298.603 35.694 298.258 35.8334 297.92 35.986C297.449 36.2051 296.997 36.444 296.539 36.6763C296.26 36.8223 295.968 36.955 295.69 37.1011C295.053 37.4395 294.435 37.7979 293.818 38.1563C293.738 38.2028 293.652 38.2493 293.566 38.2957C293.499 38.3355 293.44 38.3621 293.407 38.3886C293.36 38.3953 293.34 38.4086 293.34 38.4086C283.969 44.0301 276.794 52.2467 271.611 60.0054C271.611 60.0054 271.571 60.0651 271.511 60.1846C267.237 66.5827 264.323 72.6356 262.631 76.5846C261.403 79.4452 260.819 81.2106 260.819 81.2106C264.695 86.414 282.635 98.812 283.093 98.4536C283.093 98.4536 283.159 98.4536 283.285 98.4469C283.318 98.4403 283.345 98.4403 283.385 98.4403C283.537 98.427 283.756 98.4071 284.015 98.3872C284.141 98.3739 284.267 98.354 284.413 98.3408C284.433 98.3408 284.467 98.3407 284.5 98.3341C284.699 98.3142 284.924 98.281 285.163 98.2478C285.542 98.2014 285.973 98.1416 286.431 98.062C286.624 98.0288 286.816 97.9956 287.028 97.9492C287.626 97.843 288.256 97.7036 288.92 97.531C289.126 97.4779 289.345 97.4182 289.564 97.3585C290.008 97.2324 290.466 97.093 290.931 96.947C291.163 96.8673 291.396 96.7943 291.628 96.708C291.661 96.7014 291.714 96.6417 291.781 96.5488C291.814 96.5023 291.847 96.4558 291.893 96.3961C291.96 96.2899 292.046 96.1572 292.159 96.0045C292.212 95.9116 292.285 95.812 292.351 95.7059L292.365 95.6926C292.444 95.5798 292.517 95.447 292.61 95.3143C292.696 95.1815 292.796 95.0355 292.896 94.8895C293.095 94.5908 293.327 94.2457 293.579 93.8807C293.765 93.6019 293.971 93.3165 294.196 92.998C294.342 92.7988 294.495 92.5798 294.661 92.3542C294.741 92.248 294.82 92.1351 294.907 92.0223C295.039 91.8365 295.185 91.644 295.338 91.4449C295.371 91.3984 295.398 91.3586 295.437 91.3122C295.617 91.0732 295.809 90.8277 296.008 90.5688C296.3 90.1905 296.619 89.7923 296.957 89.3808C297.064 89.248 297.176 89.1087 297.296 88.9627C297.634 88.5445 297.999 88.1131 298.384 87.6751C298.729 87.2769 299.101 86.8587 299.479 86.434C300.209 85.6242 300.993 84.7813 301.849 83.9185C302.008 83.746 302.174 83.58 302.34 83.4141C302.499 83.2349 302.672 83.0756 302.844 82.9097C303.614 82.1464 304.444 81.3566 305.313 80.5536C305.313 80.5536 305.313 80.5602 305.32 80.5536C307.895 78.1841 310.908 75.682 314.406 73.1599C315.714 72.2108 317.074 71.2618 318.521 70.306C318.528 70.2994 318.541 70.2927 318.561 70.2861C319.045 69.9675 319.543 69.6423 320.041 69.337C320.605 68.972 321.176 68.6202 321.76 68.2552C322.218 67.9764 322.676 67.6977 323.14 67.4322C323.671 67.1136 324.216 66.8017 324.76 66.4897C325.311 66.1712 325.868 65.8592 326.432 65.5473C326.844 65.3084 321.275 55.4192 317.227 48.3043H317.22Z",
    fill: "url(#paint36_linear_122_3078)"
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M266.905 113.44C266.905 113.44 261.27 109.909 261.582 109.279C261.894 108.648 264.071 80.2284 264.682 80.6266C265.292 81.0314 270.343 84.9606 283.783 85.2327C297.223 85.5048 266.905 113.44 266.905 113.44Z",
    fill: "#D1FF86"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M323.725 110.473C323.671 111.15 323.625 111.535 323.572 111.588C322.138 112.67 298.298 125.254 272.487 116.818C272.434 116.798 272.42 116.798 272.42 116.798C271 116.34 269.567 115.803 268.133 115.199C267.781 115.046 262.956 109.106 262.956 109.106L272.474 103.823L316.603 79.3788L316.736 79.2925C316.736 79.2925 319.198 81.4164 321.136 83.1885C321.574 83.5933 321.979 83.9783 322.331 84.3035C322.935 84.8942 323.326 85.3189 323.359 85.4517C324.421 90.071 324.07 106.099 323.711 110.473H323.725Z",
    fill: "#2E8F46"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M323.572 111.588C323.134 111.907 320.685 113.274 316.776 114.794C307.65 118.338 290.559 122.725 272.493 116.818C272.44 116.798 272.427 116.798 272.427 116.798C271.451 116.48 270.469 116.121 269.474 115.736C269.036 115.57 268.578 115.385 268.14 115.199C267.788 115.046 262.963 109.106 262.963 109.106L272.48 103.823L317.638 106.338C317.638 106.338 321.959 107.938 323.578 111.588H323.572Z",
    fill: "url(#paint37_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M317.094 114.104C317.074 114.303 316.961 114.542 316.775 114.794C307.65 118.338 290.559 122.725 272.493 116.818C272.44 116.798 272.427 116.798 272.427 116.798C271.451 116.48 270.469 116.121 269.473 115.736L268.478 115.166C266.321 112.869 266.978 111.084 284.035 109.498C301.092 107.898 317.439 110.56 317.101 114.104H317.094Z",
    fill: "url(#paint38_linear_122_3078)"
  }), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M316.742 79.2992C317.705 78.9541 318.933 105.283 317.625 106.345C316.842 106.976 307.338 111.502 293.719 112.776H293.699C289.703 113.148 285.343 113.254 280.757 112.882C275.108 112.424 269.109 111.29 262.963 109.113C261.927 108.734 264.655 81.8279 265.179 82.0403C266.354 82.5447 267.642 82.996 269.049 83.3478C280.378 86.3344 298.451 84.8477 312.74 80.6C314.114 80.1885 315.455 79.7439 316.742 79.2925V79.2992Z",
    fill: "url(#paint39_linear_122_3078)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.8
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M313.344 86.0756C312.879 90.0047 304.822 91.1595 305.705 85.5513C305.705 85.5513 297.794 87.5623 290.639 87.695C282.309 87.8543 277.949 86.9782 277.949 86.9782C277.61 91.3387 272.029 92.5865 268.956 87.5291C268.305 86.4804 266.235 104.473 267.715 103.836C273.741 101.254 274.929 106.597 274.093 108.469C274.093 108.469 282.495 110.44 291.117 109.823C297.973 109.332 306.574 105.94 306.574 105.94C305.917 100.378 311.001 99.1107 313.59 101.513C314.101 101.998 313.51 84.6287 313.344 86.069V86.0756ZM299.353 97.9492C299.751 101.978 296.367 105.582 293.061 106.305C286.059 107.805 282.303 103.69 282.774 99.4293C283.245 95.1683 286.225 90.7281 291.316 90.8277C296.247 90.9339 299.041 94.7767 299.353 97.9492Z",
    fill: "#92EC38"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M316.722 104.945C316.125 107.5 297.628 112.405 293.964 109.491C290.3 106.577 289.285 88.3322 291.887 86.58C294.488 84.8212 314.24 80.4739 315.342 81.881C316.437 83.288 318.123 98.9514 316.722 104.945Z",
    fill: "#FCFFA1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M316.742 79.2992C317.704 78.9541 318.932 105.283 317.625 106.345C316.842 106.976 307.337 111.502 293.718 112.776C294.455 112.637 314.426 109.139 316.623 105.177C318.859 101.135 317.658 81.881 315.76 81.1111C315.249 80.9186 314.134 80.7394 312.74 80.6C314.114 80.1885 315.454 79.7439 316.742 79.2925V79.2992Z",
    fill: "#FFD885"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M265.179 82.0403C266.354 82.5447 267.642 82.996 269.049 83.3478C267.967 83.5137 267.038 83.7195 266.467 84.0115C264.257 85.1265 262.339 104.825 263.666 107.526C264.994 110.248 280.823 112.869 280.823 112.869L280.757 112.882C275.108 112.425 269.109 111.29 262.963 109.113C261.927 108.734 264.655 81.8279 265.179 82.0403Z",
    fill: "#FFD885"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M288.82 111.475C286.783 114.223 266.321 111.309 264.801 106.252C263.281 101.188 265.412 86.8787 268.339 85.8566C271.265 84.8345 287.958 86.0092 288.595 87.9406C289.232 89.8786 290.367 109.391 288.82 111.475Z",
    fill: "#912774"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M322.351 84.3101C322.941 84.9008 323.333 85.3256 323.373 85.465C324.441 90.0777 324.083 106.113 323.731 110.486C323.671 111.157 323.625 111.542 323.572 111.588C322.145 112.67 298.311 125.254 272.493 116.825C273.987 117.19 304.099 124.285 322.483 110.885C324.846 109.152 323.499 94.0267 322.357 84.3101H322.351Z",
    fill: "url(#paint40_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M315.893 103.969C312.78 109.663 297.004 88.737 303.375 84.569C309.747 80.4009 314.446 82.2526 315.189 83.7061C315.933 85.1597 318.621 98.9779 315.893 103.969Z",
    fill: "#FCFFA1"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M213.617 161.538C213.617 161.538 193.931 150.607 191.933 149.001C189.942 147.395 185.761 137.685 185.761 136.849C185.761 136.012 191.913 121.497 209.435 113.015C226.957 104.54 233.096 103.876 233.096 103.876L213.617 161.538Z",
    fill: "#D1FF86"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M246.748 125.307C246.748 125.307 246.231 129.083 244.478 132.827C244.233 133.344 228.649 139.324 213.616 161.545C213.371 161.897 204.789 155.977 198.716 151.742C198.683 151.729 198.67 151.709 198.67 151.709C195.643 149.625 193.267 147.952 192.842 147.674C192.384 147.368 187.301 137.599 187.301 137.599C187.301 137.599 197.468 131.466 210.829 127.252C221.939 123.734 235.253 121.544 246.742 125.307H246.748Z",
    fill: "#2E8F46"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M246.748 125.307C246.748 125.307 246.582 126.522 246.124 128.274C245.759 129.594 245.228 131.214 244.478 132.827C244.279 133.251 233.614 137.406 221.455 151.364C218.866 154.304 216.238 157.682 213.616 161.545C213.311 161.253 211.864 156.342 212.11 154.835L210.829 127.258C221.939 123.741 235.253 121.55 246.742 125.314L246.748 125.307Z",
    fill: "url(#paint41_linear_122_3078)"
  }), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M246.748 125.307C246.609 125.446 245.089 126.07 242.667 127.331C242.653 127.331 242.633 127.345 242.62 127.345C237.291 130.112 227.627 135.88 218.773 146.014C218.74 146.028 218.727 146.061 218.714 146.074C216.43 148.689 214.194 151.596 212.11 154.822C211.605 155.598 187.168 137.871 187.301 137.592C188.582 134.718 190.161 132.07 191.94 129.634C191.953 129.588 191.973 129.575 191.973 129.575C197.787 121.617 205.758 115.849 213.158 111.827C213.158 111.827 213.218 111.794 213.324 111.754C223.837 106.046 233.096 103.869 233.096 103.869C237.45 107.779 247.113 124.915 246.748 125.294V125.307Z",
    fill: "url(#paint42_linear_122_3078)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    },
    opacity: 0.8
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M232.565 107.892C232.154 111.714 227.07 114.296 223.645 109.259C223.645 109.259 214.167 112.604 208.181 117.097C200.661 122.745 195.172 130.351 195.172 130.351C197.197 131.294 200.024 136.53 193.241 138.707C191.568 139.238 208.825 150.853 208.612 149.525C207.53 143.18 211.825 140.559 216.842 142.45C216.842 142.45 219.351 139.072 226.306 133.258C232.273 128.267 238.983 126.057 238.983 126.057C231.782 122.924 238.651 118.982 241.525 121.159C242.786 122.101 232.638 107.128 232.559 107.892H232.565ZM221.9 132.561C217.791 136.271 212.176 134.751 208.752 131.586C205.327 128.42 205.48 122.36 212.296 118.604C215.521 116.838 220.877 117.389 223.419 120.98C225.43 123.807 225.868 128.951 221.9 132.561Z",
    fill: "#92EC38"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M218.714 146.074C216.43 148.689 214.194 151.596 212.11 154.822C211.605 155.598 187.168 137.871 187.301 137.592C188.582 134.718 190.161 132.07 191.94 129.634C191.542 130.198 188.256 135.097 188.635 137.287C189.059 139.616 208.984 153.01 211.174 152.598C213.231 152.2 218.096 146.738 218.707 146.068L218.714 146.074Z",
    fill: "#FFD885"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M246.748 125.307C246.609 125.446 245.089 126.07 242.667 127.331C243.622 126.449 244.386 125.566 244.571 124.849C245.182 122.533 236.461 106.146 233.036 105.064C229.811 104.042 215.03 110.951 213.331 111.761C223.844 106.053 233.103 103.876 233.103 103.876C237.457 107.785 247.12 124.922 246.755 125.3L246.748 125.307Z",
    fill: "#FFD885"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M203.674 118.803C200.74 122.732 217.877 136.855 224.388 136.218C230.899 135.581 244.877 124.995 244.293 123.057C243.708 121.126 236.355 106.119 229.758 106.285C223.16 106.451 207.397 113.812 203.674 118.796V118.803Z",
    fill: "#FCFFA1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M205.937 118.212C201.809 120.555 199.28 129.88 210.218 129.342C221.156 128.805 216.431 112.252 205.937 118.212Z",
    fill: "#FCFFA1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M217.486 112.186C214.34 112.849 214.161 118.239 217.871 117.575C221.581 116.911 222.138 111.203 217.486 112.186Z",
    fill: "#FCFFA1"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M246.124 128.274C245.759 129.595 245.228 131.214 244.478 132.827C244.279 133.252 233.614 137.406 221.455 151.364C221.395 151.271 221.348 151.198 221.302 151.105C220.373 148.928 230.554 132.628 239.308 129.648C242.169 128.672 244.405 128.307 246.124 128.28V128.274Z",
    fill: "url(#paint43_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M244.478 132.82C244.233 133.338 228.649 139.318 213.616 161.538C213.371 161.89 204.789 155.97 198.716 151.736C199.506 152.253 211.167 159.74 212.853 159.361C214.572 158.963 233.793 135.043 244.478 132.82Z",
    fill: "url(#paint44_linear_122_3078)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M190.161 137.718C188.654 135.05 202.758 129.349 207.577 133.789C212.395 138.229 214.678 149.771 211.804 150.236C208.931 150.7 192.358 141.614 190.161 137.725V137.718Z",
    fill: "#912774"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M252.702 113.852C251.222 108.23 248.003 149.957 251.089 148.543C254.175 147.129 261.94 115.205 259.843 116.201C257.746 117.203 253.345 116.294 252.702 113.852Z",
    fill: "#CC8D83"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M278.48 220.88C278.221 221.942 274.146 222.433 269.64 221.524C265.717 220.754 258.304 217.429 256.551 217.329L255.775 216.599C247.147 207.566 246.038 189.865 255.111 191.856C257.175 192.308 260.102 194.312 263.401 197.139C263.739 198.049 264.091 198.925 264.436 199.768C269.334 211.595 274.471 216.878 276.96 219.221L276.987 219.247C277.976 220.19 278.533 220.648 278.48 220.88Z",
    fill: "#E8AFD1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_122_3078",
    x1: 9,
    y1: 32.5,
    x2: 308.926,
    y2: 225.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE4515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.487354,
    stopColor: "#FE6F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832128,
    stopColor: "#FE7803"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_122_3078",
    x1: 314.112,
    y1: 99.474,
    x2: 236.677,
    y2: 117.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_122_3078",
    x1: 254.198,
    y1: 112.278,
    x2: 242.424,
    y2: 58.4162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20903E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31AC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_122_3078",
    x1: 251.231,
    y1: 85.6226,
    x2: 257.666,
    y2: 124.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_122_3078",
    x1: 217.36,
    y1: -74.8395,
    x2: 255.186,
    y2: 156.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_122_3078",
    x1: 245.129,
    y1: 70.3591,
    x2: 248.64,
    y2: 112.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F9F6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EAECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D0DBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ADC4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#80A6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B84FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_122_3078",
    x1: 277.491,
    y1: 114.051,
    x2: 301.955,
    y2: -1.79175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_122_3078",
    x1: 288.701,
    y1: 25.4747,
    x2: 263.471,
    y2: 74.5042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20903E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31AC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_122_3078",
    x1: 197.929,
    y1: 193.196,
    x2: 315.939,
    y2: -9.04868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_122_3078",
    x1: 285.92,
    y1: 21.7033,
    x2: 278.546,
    y2: 55.4923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F9F6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EAECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D0DBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ADC4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#80A6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B84FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_122_3078",
    x1: 256.512,
    y1: 222.718,
    x2: 252.583,
    y2: 155.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#732F52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#773050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#83364D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#973F47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A44544"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_122_3078",
    x1: 253.12,
    y1: 90.0446,
    x2: 253.379,
    y2: 75.5493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F9F6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EAECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D0DBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ADC4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#80A6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B84FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_122_3078",
    x1: 257.208,
    y1: 118.869,
    x2: 268.87,
    y2: 102.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F9F6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EAECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D0DBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ADC4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#80A6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B84FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_122_3078",
    x1: 233.786,
    y1: 185.73,
    x2: 233.786,
    y2: 118.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9B1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C15DAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_122_3078",
    x1: 244.512,
    y1: 147.355,
    x2: 241.372,
    y2: 141.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9B1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C15DAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_122_3078",
    x1: 240.198,
    y1: 141.893,
    x2: 236.786,
    y2: 135.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F9F6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EAECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D0DBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ADC4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#80A6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B84FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_122_3078",
    x1: 260.427,
    y1: 154.443,
    x2: 260.427,
    y2: 84.7814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9B1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C15DAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_122_3078",
    x1: 252.616,
    y1: 89.2481,
    x2: 278.573,
    y2: 299.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9B1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C15DAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_122_3078",
    x1: 253,
    y1: 246.671,
    x2: 243.377,
    y2: -1.13467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9B1D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C15DAD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_122_3078",
    x1: 268.458,
    y1: 105.164,
    x2: 222.835,
    y2: 105.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_122_3078",
    x1: 232.152,
    y1: 106.562,
    x2: 192.993,
    y2: 67.7425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62A635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74C200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_122_3078",
    x1: 239.932,
    y1: 27.2784,
    x2: 234.105,
    y2: 137.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_122_3078",
    x1: 218.435,
    y1: 15.2985,
    x2: 211.884,
    y2: 138.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_122_3078",
    x1: 208.161,
    y1: 81.9805,
    x2: 231.829,
    y2: 123.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F9F6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EAECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D0DBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ADC4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#80A6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B84FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_122_3078",
    x1: 220.546,
    y1: 95.248,
    x2: 223.373,
    y2: 118.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F9F6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EAECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D0DBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ADC4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#80A6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B84FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_122_3078",
    x1: 273.729,
    y1: 122.032,
    x2: 216.935,
    y2: -2.18326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_122_3078",
    x1: 248.162,
    y1: 80.5403,
    x2: 248.162,
    y2: 16.5065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62A635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74C200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_122_3078",
    x1: 259.978,
    y1: 61.7236,
    x2: 224.195,
    y2: 61.9094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_122_3078",
    x1: 257.414,
    y1: 48.6728,
    x2: 216.81,
    y2: 48.8926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_122_3078",
    x1: 244.717,
    y1: 42.8222,
    x2: 260.925,
    y2: 77.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F9F6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EAECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D0DBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ADC4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#80A6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B84FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_122_3078",
    x1: 252.781,
    y1: 49.8906,
    x2: 271.902,
    y2: 75.6157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F9F6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EAECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D0DBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ADC4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#80A6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B84FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_122_3078",
    x1: 351.168,
    y1: 17.0839,
    x2: 254.089,
    y2: 117.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_122_3078",
    x1: 290.008,
    y1: 98.4603,
    x2: 290.008,
    y2: 34.0747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62A635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74C200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_122_3078",
    x1: 258.47,
    y1: 47.8066,
    x2: 295.942,
    y2: 98.2213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F9F6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EAECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D0DBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ADC4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#80A6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B84FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_122_3078",
    x1: 290.626,
    y1: 61.1603,
    x2: 303.873,
    y2: 94.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_122_3078",
    x1: 281.626,
    y1: 12.5243,
    x2: 314.121,
    y2: 93.7746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_122_3078",
    x1: 297.495,
    y1: 63.8349,
    x2: 286.006,
    y2: 91.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F9F6FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#EAECFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#D0DBFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#ADC4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#80A6FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B84FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_122_3078",
    x1: 405.446,
    y1: 109.59,
    x2: 253.717,
    y2: 112.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_122_3078",
    x1: 300.946,
    y1: 185.737,
    x2: 287.168,
    y2: 70.4587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_122_3078",
    x1: 318.618,
    y1: 97.7309,
    x2: 263.673,
    y2: 93.0977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62A635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74C200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_122_3078",
    x1: 128.964,
    y1: 77.7555,
    x2: 360.911,
    y2: 109.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_122_3078",
    x1: 272.175,
    y1: 83.819,
    x2: 183.571,
    y2: 175.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_122_3078",
    x1: 217.028,
    y1: 154.855,
    x2: 217.028,
    y2: 103.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62A635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#74C200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_122_3078",
    x1: 224.421,
    y1: 116.453,
    x2: 236.846,
    y2: 147.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_122_3078",
    x1: 213.948,
    y1: 123.157,
    x2: 228.052,
    y2: 158.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FBF4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F0E5F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DFCBEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C7A8E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A87AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#8343C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732CBA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_3078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 342,
    height: 212,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNewFront4);
export default __webpack_public_path__ + "static/media/bg-new-front-4.5fefd3fde967bdcbad2fb6fdb207cffd.svg";
export { ForwardRef as ReactComponent };